module.exports = __webpack_public_path__ + "img/ch36.10ca2468.png";